import { Link } from '../ui';
import {
  getCommentDisplayAuthor,
  useCommentAuthorLink,
} from '../../models/comments/helpers';
import { Comment } from '../../models/comments/types';

type CommentAuthorName = {
  comment: Comment;
};

const CommentAuthorName = ({ comment }: CommentAuthorName) => {
  const { name } = getCommentDisplayAuthor(comment);
  const href = useCommentAuthorLink(comment);

  return (
    <div className="author-name">
      {href ? (
        <Link href={href} action="push">
          {name}
        </Link>
      ) : (
        name
      )}
    </div>
  );
};

export default CommentAuthorName;
